import React from "react"
import tw, { styled } from "twin.macro"
import SEO from "./seo"
import { H1, DiagonalBox } from "./page-elements"

const InnerDiagonalBox = styled(DiagonalBox)`
  height: 450px;

  @media (min-width: 1024px) {
    height: 600px;
  }
`

const InnerH1 = styled(H1)`
  ${tw` text-center uppercase text-base-color my-8 md:my-16 xl:my-20 `}
`

interface BannerProps {
  title: string
  header: string
  desctiption: string
}

export const Banner: React.FC<BannerProps> = ({
  title,
  header,
  desctiption,
}) => {
  return (
    <>
      <SEO title={title} description={desctiption} />
      <InnerDiagonalBox top="-20%" />
      <InnerH1 className="text-center uppercase text-base-color md:my-16">
        {header}
      </InnerH1>
    </>
  )
}
